import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import {
  ButtonComponent,
  CcsInputComponent,
  DashboardAlertComponent,
} from '@shared/components';

@Component({
  selector: 'app-courtfile-update-modal',
  templateUrl: 'courtfile-update-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    CcsInputComponent,
    ButtonComponent,
    MatDialogModule,
    DashboardAlertComponent,
  ],
})
export class CourtFileUpdateModalComponent {
  private readonly _data: {
    fileNumber: string | null;
  } = inject(MAT_DIALOG_DATA);

  private readonly _fb = inject(FormBuilder);

  protected form = this._fb.group({
    fileNumber: this._fb.control<string | null>(
      this._data.fileNumber,

      [Validators.required],
    ),
  });

  protected get currentFileNumber() {
    return this._data.fileNumber;
  }
}
